import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import { Snackbar } from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomSelect, CustomTextField, CustomThemeProvider } from "../../../../Styles/theme/customThemeprovider";
import BasicPopover from "../../../../Components/Popover";
import { IControloA2, IControloCabA2 } from "../../../../Interfaces/anexos/anexo2/controlo";
import { ButtonCadernos } from "../../../../Components/barra-de-ferramentas/ButtonCadernos";
import ConfirmDialog from "../../../../Components/CustomDialog/customdialog";
import { func_print } from "../../../../Func_genericas/func_print";
import { del, get, post } from "../../../../Services/tokenConfig";
import { useLocation } from "react-router-dom";
import { StyledTableCell, StyledTableHead } from "../../../../Styles/tabelCellStyled/customTableCell";
import { BarraDeFerramentas } from "../../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { Alert } from "../../../../Components/Alert/Alert";
import { grauinfestante, tipoIntervencao } from "../../../../informacao_estatica";
import { AuthContext } from "../../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { IZonaHomogenea } from "../../../../Interfaces/cadernos/zona_homogenea";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../../Func_genericas/valores_estaticos";
interface ControloVegetacaoAreaForm_prop {
  zona_lista: IZonaHomogenea[]

}
export const ControloVegetacaoAreaForm: React.FC<ControloVegetacaoAreaForm_prop> = ({
  zona_lista
}) => {
  const location = useLocation();
  const auth = useContext(AuthContext);

  const is_historico = location.state?.is_historico ?? false;

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<IControloCabA2>();
  const [obj_anexo, set_obj_anexo] = useState<IControloA2>();
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
  const [obj_anexo_lista_cabecalho, set_obj_anexo_lista_cabecalho] = useState<IControloCabA2[]>([]);
  const [obj_anexo_lista, set_obj_anexo_lista] = useState<IControloA2[]>([]);
  const [flag_criar_novo_anexo, set_flag_criar_novo_anexo] = useState(false);
  const [flag_criar_novo_cabecalho, set_flag_criar_novo_cabecalho] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error_area, set_error_area] = useState(false);
  const [error_area_intervencionar, set_error_area_intervencionar] = useState(false);
  const [message, setMessage] = useState("");
  const [id_do_cabecalho_onde_vai_ser_adicionada_info, set_id_do_cabecalho_onde_vai_ser_adicionada_info] = useState<number>()
  const [openSnackSuccess, setOpenSnackSuccess] = useState(false);
  const [openSnackError, setOpenSnackError] = useState(false);

  const [zona_selecionada, set_zona_selecionada] = useState<IZonaHomogenea>();
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handle_close_adicionar_anexo_cabecalho()
    handle_close_adicionar_anexo()
    set_error_area(false)
    set_error_area_intervencionar(false)

    set_obj_anexo_cabecalho(undefined)

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  const onInputEditTableChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo(aux_obj_anexo);

    } else {
      if (name === 'area_intervencionar') {

        if (/[a-zA-Z]/.test(value)) {
          set_error_area_intervencionar(true)

        } else {
          set_error_area_intervencionar(false)

        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'area') {

        if (/[a-zA-Z]/.test(value)) {
          set_error_area(true)

        } else {
          set_error_area(false)

        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));
      }

    }
  };

  const onInputEditTableChange_cabecalho = (event: any) => {
    const { name, value, type, checked } = event.target;
    let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
    set_flag_editado(true)

    if (type === "checkbox") {
      aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
      set_obj_anexo_cabecalho(aux_obj_anexo);

    } else {

      set_obj_anexo_cabecalho((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
  };
  const handle_delete_anexo = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_dois_control_dois/${obj_anexo?.id_controlo}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista.filter((el) => {
          if (el.id_controlo !== obj_anexo?.id_controlo) {
            return el
          }
        })
        set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
        setMessage("Registo eliminado com sucesso!");
        set_obj_anexo(undefined)
        set_zona_selecionada(undefined)
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };
  const handle_delete_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_dois_control_um/${obj_anexo_cabecalho?.id_controlo_cabecalho}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.filter((el) => {
          if (el.id_controlo_cabecalho !== obj_anexo_cabecalho?.id_controlo_cabecalho) {
            return el
          }
        })
        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        setMessage("Registo eliminado com sucesso!");
        set_obj_anexo_cabecalho(undefined)

        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };

  const handle_create_anexo = async () => {
    if (error_area === true) {
      set_error_area(true)
      setMessage("Preenchimento da área é numérico!");
      setOpenSnackError(true);

    } else if (error_area_intervencionar === true) {
      set_error_area_intervencionar(true)
      setMessage("Preenchimento da área a intervencionar é numérico!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "new_reg_anexo_dois_control_dois", {
          payload: {
            id_controlo: 0,
            zona_homo: obj_anexo?.zona_homo === undefined ? '' : obj_anexo?.zona_homo,
            area: obj_anexo?.area === undefined ? 0 : obj_anexo?.area,
            grau: obj_anexo?.grau === undefined ? '' : obj_anexo?.grau,
            tipo: obj_anexo?.tipo === undefined ? '' : obj_anexo?.tipo,
            area_intervencionar: obj_anexo?.area_intervencionar === undefined ? 0 : obj_anexo?.area_intervencionar,
            id_controlo_cabecalho: id_do_cabecalho_onde_vai_ser_adicionada_info,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ''
          }
        });

        if (res.status === 200) {
          set_obj_anexo_lista((old) => [...old, res.data.result])
          set_obj_anexo(undefined);
          set_zona_selecionada(undefined)
          set_flag_editado(false)

          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);


          set_flag_criar_novo_anexo(false);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);

        }

        setIsLoading(false);
      } catch (error) {
        func_print("handle_create_anexo", error, true);
        setIsLoading(false);
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);

      }
    }
  };
  const handle_create_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_anexo_dois_control_um", {
        payload: {

          id_controlo_cabecalho: 0,
          data: obj_anexo_cabecalho?.data === undefined ? '' : obj_anexo_cabecalho?.data,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ''
        }
      });

      if (res.status === 200) {
        set_obj_anexo_lista_cabecalho((old) => [...old, res.data.result])
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)
        set_flag_editado(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);


        set_flag_criar_novo_anexo(false);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);

      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_create_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);

    }
  };

  const handle_update_anexo = async () => {
    if (error_area === true) {
      set_error_area(true)
      setMessage("Preenchimento da área é numérico!");
      setOpenSnackError(true);

    } else if (error_area_intervencionar === true) {
      set_error_area_intervencionar(true)
      setMessage("Preenchimento da área a intervencionar é numérico!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "update_reg_anexo_dois_control_dois", { payload: obj_anexo });

        if (res.status === 200) {
          let lista_aux: any = obj_anexo_lista.map((el) => {
            if (el.id_controlo !== obj_anexo?.id_controlo) {
              return el
            } else {
              return res.data.result
            }
          })
          set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
          set_obj_anexo(undefined);
          set_flag_criar_novo_anexo(false)
          set_zona_selecionada(undefined)
          set_flag_editado(false)

          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");

          setOpenSnackError(true);
        }

        setIsLoading(false);
      } catch (error) {
        func_print("handle_update_anexo", error, true);
        setMessage("Erro ao gravar!");

        setOpenSnackError(true);
        setIsLoading(false);
      }
    }

  };
  const handle_update_anexo_cabecalho = async () => {
    try {
      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "update_reg_anexo_dois_control_um", { payload: obj_anexo_cabecalho });

      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista_cabecalho.map((el) => {
          if (el.id_controlo_cabecalho !== obj_anexo_cabecalho?.id_controlo_cabecalho) {
            return el
          } else {
            return res.data.result
          }
        })
        set_obj_anexo_lista_cabecalho(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho(undefined);
        set_flag_criar_novo_cabecalho(false)
        set_flag_editado(false)

        setMessage("Gravado com sucesso!");
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("handle_update_anexo", error, true);
      setMessage("Erro ao gravar!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };
  const handle_escolhe_qual_elimina = async () => {

    if (obj_anexo !== undefined) {

      await handle_delete_anexo()
    } else if (obj_anexo_cabecalho !== undefined) {

      await handle_delete_anexo_cabecalho()
    }
  }


  const get_info = async () => {
    try {
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_anexo_dois_all_vegetacao_arbusitiva/${location.state.id_rosto}`
      );

      if (res_cabecalho.status === 200) {
        if (res_cabecalho.data.result.length !== 0) {
          set_obj_anexo_lista_cabecalho(res_cabecalho.data.result[0]);
          set_obj_anexo_lista(res_cabecalho.data.result[1]);

        }
      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  const handle_close_adicionar_anexo_cabecalho = () => {
    set_obj_anexo_cabecalho(undefined)
    set_flag_criar_novo_cabecalho(false)
  }
  const handle_close_adicionar_anexo = () => {
    set_obj_anexo(undefined)
    set_flag_criar_novo_anexo(false)
    set_zona_selecionada(undefined)

  }

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_zona_selecionada(undefined)

    let aux_obj_zona_homogenea_selecionada = zona_lista.find((el: IZonaHomogenea) => el.zona_homogenea === zona_homogenea_selecionada)

    set_zona_selecionada(aux_obj_zona_homogenea_selecionada)

    set_obj_anexo((old: any) => ({
      ...old,
      ['area']: aux_obj_zona_homogenea_selecionada?.area,
      ['zona_homo']: aux_obj_zona_homogenea_selecionada?.zona_homogenea,
    }));
  }

  return (
    <CustomThemeProvider>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          height: "auto",
          width: "auto",
          margin: 2,
          padding: 2,
        }}
      >
        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <table style={{ width: "75%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={4}
                sx={{
                  fontWeight: 600,
                  fontFamily: "candara",
                  fontSize: 16,
                }}
              >
                <Stack direction="row" alignItems="center">
                  3 - Controlo da vegetação arbustiva

                  <BasicPopover
                    text={
                      "Preencher quando houver necessidade de o beneficiário implementar ações de controlo da vegetação arbustiva nas parcelas candidatas, indicando a sua frequência.\n\nNo caso do regime ecológico «maneio da pastagem permanente», as alterações a implementar no maneio do pastoreio devem ser propostas para 3 anos.\n\nNo caso da intervenção agroambiental «conservação do solo - pastagens biodiversas, as alterações a implementar no maneio do pastoreio devem ser propostas para 5 anos."
                    }
                  />
                </Stack>
              </TableCell>
              <TableCell colSpan={2}>
                <Stack direction="row" sx={{ justifyContent: "end" }}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Adicionar cabeçalho"
                      aoClicarNovo={() => set_flag_criar_novo_cabecalho(true)}
                    />}
                </Stack>
              </TableCell>
            </TableRow>
          </TableHead>




          {flag_criar_novo_cabecalho === true ?
            <TableBody>
              <TableRow>
                <StyledTableHead rowSpan={2}>
                  Zona homogénea
                  <BasicPopover
                    text={
                      "Preencher com a zona homogénea indicada no quadro 1 anterior como tendo necessidade de intervenção no controlo da vegetação arbustiva."
                    }
                  />
                </StyledTableHead>
                <StyledTableHead rowSpan={2}>
                  Área (Ha)
                  <BasicPopover
                    text={
                      "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                    }
                  />
                </StyledTableHead>
                <StyledTableHead colSpan={3} width={500}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      sx={{ paddingRight: 2, fontFamily: "candara" }}
                    >
                      Ano:
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        views={["year"]}
                        label={
                          <Typography fontFamily="candara" fontSize={14}>
                            Selecionar ano
                          </Typography>
                        }
                        value={obj_anexo_cabecalho?.data === undefined ? null : dayjs(obj_anexo_cabecalho?.data)}
                        onChange={(newValue) => {
                          onInputEditTableChange_cabecalho({
                            target: {
                              name: "data",
                              value: newValue ? newValue.format("YYYY") : "",
                            },
                          });
                        }}

                        minDate={dayjs("2010")}
                        slots={{
                          textField: textFieldProps => <TextField {...textFieldProps} />
                        }}
                      />
                    </LocalizationProvider>
                  </Stack>
                </StyledTableHead>
                <StyledTableHead rowSpan={2} width={150}>


                  <ButtonCadernos
                    mostrarBotaoGravar
                    aoClicarGravar={() => handle_create_anexo_cabecalho()}
                    mostrarBotaoCancelar
                    aoClicarCancelar={() => {
                      if (flag_editado) {
                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                      } else {
                        handle_close_adicionar_anexo_cabecalho()
                      }
                    }}
                  />

                </StyledTableHead>
              </TableRow>
              <TableRow>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Grau infestantes
                    <BasicPopover
                      text={
                        "Indicar o grau de infestação (vegetação arbustiva): \n - grau de infestação elevado - ≥ 30%; \n- grau de infestação médio – > 15% e < 30%;\n- grau de infestação baixo - ≤ 15%"
                      }
                    />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Tipo intervenção
                    <BasicPopover
                      text={
                        "Indicar o método/prática a utilizar no controlo da vegetação arbustiva: \n- Corte; \n - Arranque; \n- Outro."
                      }
                    />
                  </Stack>
                </StyledTableHead>
                <StyledTableHead>
                  <Stack direction="row" justifyContent="center" alignItems="center">
                    Área a intervencionar
                    <BasicPopover
                      text={
                        "indicar a área da zona homogémea que irá ser intrevencionada em cada um dos anos (área onde irá ser efetuado o controlo da vegetação arbustiva). Caso a intervenção seja realizada na totalidade da zona homogénea preencher com o alor indicado no campo 'Área' deste mesmo quadro."
                      }
                    />
                  </Stack>
                </StyledTableHead>
              </TableRow>
            </TableBody>
            : <></>}

          {obj_anexo_lista_cabecalho.length === 0 ?
            <></>
            :
            obj_anexo_lista_cabecalho.map((tab, key) => {
              if (obj_anexo_cabecalho?.id_controlo_cabecalho !== tab.id_controlo_cabecalho) {

                return (
                  <TableBody key={key}>
                    <TableRow >
                      <TableCell colSpan={7}>
                        <Stack direction="row" sx={{ justifyContent: "end" }}>
                          {is_historico === true ? <></> :

                            <BarraDeFerramentas
                              mostrarBotaoNovo
                              textoBotaoNovo="Adicionar informação"
                              aoClicarNovo={() => {
                                set_flag_criar_novo_anexo(true)
                                set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_controlo_cabecalho)
                              }}
                            />}
                        </Stack>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <StyledTableHead rowSpan={2}>
                        Zona homogénea
                        <BasicPopover
                          text={
                            "Preencher com a zona homogénea indicada no quadro 1 anterior como tendo necessidade de intervenção no controlo da vegetação arbustiva."
                          }
                        />
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        Área (Ha)
                        <BasicPopover
                          text={
                            "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                          }
                        />
                      </StyledTableHead>
                      <StyledTableHead colSpan={3}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          Ano:
                          <Typography
                            sx={{
                              paddingLeft: 2,
                              fontFamily: "candara",
                              fontWeight: 600,
                            }}
                          >
                            {tab.data}
                          </Typography>
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        {is_historico === true ? <></> :

                          <ButtonCadernos
                            mostrarBotaoEditar
                            aoClicarEditar={() => {
                              set_obj_anexo_cabecalho(tab)
                            }}
                            mostrarBotaoApagar
                            aoClicarApagar={() => {
                              set_obj_anexo_cabecalho(tab)
                              set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                            }}
                          />}
                      </StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Grau infestantes
                          <BasicPopover
                            text={
                              "Indicar o grau de infestação (vegetação arbustiva): \n - grau de infestação elevado - ≥ 30%; \n- grau de infestação médio – > 15% e < 30%;\n- grau de infestação baixo - ≤ 15%"
                            }
                          />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Tipo intervenção
                          <BasicPopover
                            text={
                              "Indicar o método/prática a utilizar no controlo da vegetação arbustiva: \n- Corte; \n - Arranque; \n- Outro."
                            }
                          />
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Área a intervencionar
                          <BasicPopover
                            text={
                              "indicar a área da zona homogémea que irá ser intrevencionada em cada um dos anos (área onde irá ser efetuado o controlo da vegetação arbustiva). Caso a intervenção seja realizada na totalidade da zona homogénea preencher com o alor indicado no campo 'Área' deste mesmo quadro."
                            }
                          />
                        </Stack>
                      </StyledTableHead>
                    </TableRow>
                    {
                      id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_controlo_cabecalho && (flag_criar_novo_anexo === true || obj_anexo_lista.length === 0) ?
                        <TableRow>
                          <StyledTableCell>
                            <Select
                              value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                              label={''}
                              name={'zona_homogenea'}
                              sx={{
                                fontSize: 14,
                                fontFamily: "verdana",
                                minWidth: 200,
                              }}
                              onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                            >

                              {zona_lista.map((item: IZonaHomogenea, key) => {

                                return (
                                  <MenuItem key={key} value={item.zona_homogenea}>
                                    <Typography
                                      style={{
                                        fontSize: 14,
                                        fontFamily: "candara",
                                      }}
                                    >
                                      {item.zona_homogenea}
                                    </Typography>
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="area"
                              value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                              onChange={onInputEditTableChange}
                              error={error_area}
                              helperText={error_area ? "Apenas números são aceites" : ""}

                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              name="grau"
                              value={obj_anexo?.grau === undefined ? '' : obj_anexo?.grau}
                              onChange={onInputEditTableChange}
                              options={grauinfestante}
                              label=""
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomSelect
                              name="tipo"
                              value={obj_anexo?.tipo === undefined ? '' : obj_anexo?.tipo}
                              onChange={onInputEditTableChange}
                              options={tipoIntervencao}
                              label=""
                            />

                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="area_intervencionar"
                              value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                              onChange={onInputEditTableChange}
                              error={error_area_intervencionar}
                              helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>

                            <ButtonCadernos
                              mostrarBotaoGravar
                              aoClicarGravar={() =>
                                handle_create_anexo()
                              }
                              mostrarBotaoCancelar
                              aoClicarCancelar={() => {

                                if (flag_editado) {
                                  set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                } else {
                                  handle_close_adicionar_anexo()
                                }
                              }}
                            />
                          </StyledTableCell>
                        </TableRow> :
                        <></>

                    }
                    {
                      obj_anexo_lista.length !== 0 ?

                        obj_anexo_lista.map((elem, key1) => {
                          if (tab.id_controlo_cabecalho === elem.id_controlo_cabecalho && id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_controlo_cabecalho && elem.id_controlo === obj_anexo?.id_controlo) {
                            return (

                              <TableRow key={key1}>
                                <StyledTableCell>

                                  <Select
                                    value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                                    label={''}
                                    name={'zona_homogenea'}
                                    sx={{
                                      fontSize: 14,
                                      fontFamily: "verdana",
                                      minWidth: 200,
                                    }}
                                    onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                                  >

                                    {zona_lista.map((item: IZonaHomogenea, key) => {

                                      return (
                                        <MenuItem key={key} value={item.zona_homogenea}>
                                          <Typography
                                            style={{
                                              fontSize: 14,
                                              fontFamily: "candara",
                                            }}
                                          >
                                            {item.zona_homogenea}
                                          </Typography>
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="area"
                                    value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                                    onChange={onInputEditTableChange}
                                    error={error_area}
                                    helperText={error_area ? "Apenas números são aceites" : ""}

                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomSelect
                                    name="grau"
                                    value={obj_anexo?.grau === undefined ? '' : obj_anexo?.grau}
                                    onChange={onInputEditTableChange}
                                    options={grauinfestante}
                                    label=""
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomSelect
                                    name="tipo"
                                    value={obj_anexo?.tipo === undefined ? '' : obj_anexo?.tipo}
                                    onChange={onInputEditTableChange}
                                    options={tipoIntervencao}
                                    label=""
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="area_intervencionar"
                                    value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                                    onChange={onInputEditTableChange}
                                    error={error_area_intervencionar}
                                    helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}
                                  />
                                </StyledTableCell>

                                <StyledTableCell>

                                  <ButtonCadernos
                                    mostrarBotaoGravar
                                    aoClicarGravar={() =>
                                      handle_update_anexo()
                                    }
                                    mostrarBotaoCancelar
                                    aoClicarCancelar={() => {
                                      if (flag_editado) {
                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                      } else {
                                        handle_close_adicionar_anexo()
                                      }
                                    }}
                                  />
                                </StyledTableCell>
                              </TableRow>

                            )

                          } else if (tab.id_controlo_cabecalho === elem.id_controlo_cabecalho) {
                            return (
                              <TableRow key={key1}>
                                <StyledTableCell>
                                  {elem.zona_homo}

                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.area.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.grau}


                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.tipo}


                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.area_intervencionar.toString().replace('.', ',')}


                                </StyledTableCell>

                                <StyledTableCell>
                                  {is_historico === true ? <></> :

                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        set_obj_anexo(elem)
                                        set_zona_selecionada((old: any) => ({
                                          ...old,
                                          ['zona_homogenea']: elem?.zona_homo,
                                        }))
                                        set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_controlo_cabecalho)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => {
                                        set_obj_anexo(elem)
                                        set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                      }}
                                    />}
                                </StyledTableCell>
                              </TableRow>

                            )
                          }
                        })
                        :
                        <></>
                    }
                  </TableBody>

                )
              } else {
                return (

                  <TableBody key={key}>

                    <TableRow>
                      <StyledTableHead rowSpan={2}>
                        Zona homogénea
                        <BasicPopover
                          text={
                            "Preencher com a zona homogénea indicada no quadro 1 anterior como tendo necessidade de intervenção no controlo da vegetação arbustiva."
                          }
                        />
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        Área (Ha)
                        <BasicPopover
                          text={
                            "Preencher com a área correspondente à zona homogénea (soma da área de todas as subparcelas que constituem a zona homogénea)."
                          }
                        />
                      </StyledTableHead>
                      <StyledTableHead colSpan={3}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Typography
                            sx={{ paddingRight: 2, fontFamily: "candara" }}
                          >
                            Ano:
                          </Typography>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              views={["year"]}
                              label={
                                <Typography fontFamily="candara" fontSize={14}>
                                  Selecionar ano
                                </Typography>
                              }
                              value={obj_anexo_cabecalho?.data === undefined ? null : dayjs(obj_anexo_cabecalho?.data)}
                              onChange={(newValue) => {
                                onInputEditTableChange_cabecalho({
                                  target: {
                                    name: "data",
                                    value: newValue
                                      ? newValue.format("YYYY")
                                      : "",
                                  },
                                });
                              }}
                              minDate={dayjs("2010")}
                              slots={{
                                textField: textFieldProps => <TextField {...textFieldProps} />
                              }}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </StyledTableHead>
                      <StyledTableHead rowSpan={2}>
                        <ButtonCadernos
                          mostrarBotaoGravar
                          aoClicarGravar={() => handle_update_anexo_cabecalho()}
                          mostrarBotaoCancelar
                          aoClicarCancelar={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                            } else {
                              set_obj_anexo_cabecalho(undefined)
                            }
                          }}
                        />

                      </StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Grau infestantes
                          <BasicPopover
                            text={
                              "Indicar o grau de infestação (vegetação arbustiva): \n - grau de infestação elevado - ≥ 30%; \n- grau de infestação médio – > 15% e < 30%;\n- grau de infestação baixo - ≤ 15%"
                            }
                          />
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Tipo intervenção
                          <BasicPopover
                            text={
                              "Indicar o método/prática a utilizar no controlo da vegetação arbustiva: \n- Corte; \n - Arranque; \n- Outro."
                            }
                          />
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          Área a intervencionar
                          <BasicPopover
                            text={
                              "indicar a área da zona homogémea que irá ser intrevencionada em cada um dos anos (área onde irá ser efetuado o controlo da vegetação arbustiva). Caso a intervenção seja realizada na totalidade da zona homogénea preencher com o alor indicado no campo 'Área' deste mesmo quadro."
                            }
                          />
                        </Stack>
                      </StyledTableCell>


                    </TableRow>
                    {
                      obj_anexo_lista.length !== 0 ?

                        obj_anexo_lista.map((elem, key1) => {
                          if (tab.id_controlo_cabecalho === elem.id_controlo_cabecalho && id_do_cabecalho_onde_vai_ser_adicionada_info === tab.id_controlo_cabecalho && elem.id_controlo === obj_anexo?.id_controlo) {
                            return (

                              <TableRow key={key1}>
                                <StyledTableCell>

                                  <Select
                                    value={zona_selecionada?.zona_homogenea === undefined ? '' : zona_selecionada?.zona_homogenea}
                                    label={''}
                                    name={'zona_homogenea'}
                                    sx={{
                                      fontSize: 14,
                                      fontFamily: "verdana",
                                      minWidth: 200,
                                    }}
                                    onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                                  >

                                    {zona_lista.map((item: IZonaHomogenea, key) => {

                                      return (
                                        <MenuItem key={key} value={item.zona_homogenea}>
                                          <Typography
                                            style={{
                                              fontSize: 14,
                                              fontFamily: "candara",
                                            }}
                                          >
                                            {item.zona_homogenea}
                                          </Typography>
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="area"
                                    value={obj_anexo?.area === undefined ? '' : obj_anexo?.area.toString().replace('.', ',')}
                                    onChange={onInputEditTableChange}
                                    error={error_area}
                                    helperText={error_area ? "Apenas números são aceites" : ""}

                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomSelect
                                    name="grau"
                                    value={obj_anexo?.grau === undefined ? '' : obj_anexo?.grau}
                                    onChange={onInputEditTableChange}
                                    options={grauinfestante}
                                    label=""
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomSelect
                                    name="tipo"
                                    value={obj_anexo?.tipo === undefined ? '' : obj_anexo?.tipo}
                                    onChange={onInputEditTableChange}
                                    options={tipoIntervencao}
                                    label=""
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="area_intervencionar"
                                    value={obj_anexo?.area_intervencionar === undefined ? '' : obj_anexo?.area_intervencionar.toString().replace('.', ',')}
                                    onChange={onInputEditTableChange}
                                    error={error_area_intervencionar}
                                    helperText={error_area_intervencionar ? "Apenas números são aceites" : ""}
                                  />
                                </StyledTableCell>

                                <StyledTableCell>

                                  <ButtonCadernos
                                    mostrarBotaoGravar
                                    aoClicarGravar={() =>
                                      handle_create_anexo()
                                    }
                                    mostrarBotaoCancelar
                                    aoClicarCancelar={() => {
                                      if (flag_editado) {
                                        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                      } else {
                                        handle_close_adicionar_anexo()

                                      }
                                    }}
                                  />
                                </StyledTableCell>
                              </TableRow>

                            )

                          } else if (tab.id_controlo_cabecalho === elem.id_controlo_cabecalho) {
                            return (
                              <TableRow key={key1}>
                                <StyledTableCell>
                                  {elem.zona_homo}

                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.area.toString().replace('.', ',')}

                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.grau}


                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.tipo}


                                </StyledTableCell>
                                <StyledTableCell>
                                  {elem.area_intervencionar.toString().replace('.', ',')}


                                </StyledTableCell>

                                <StyledTableCell>
                                  {is_historico === true ? <></> :

                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        set_obj_anexo(elem)
                                        set_zona_selecionada((old: any) => ({
                                          ...old,
                                          ['zona_homogenea']: elem?.zona_homo,
                                        }))
                                        set_id_do_cabecalho_onde_vai_ser_adicionada_info(tab.id_controlo_cabecalho)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => {
                                        set_obj_anexo(elem)
                                        set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                      }}
                                    />}
                                </StyledTableCell>
                              </TableRow>

                            )
                          }
                        })
                        :
                        <></>
                    }

                  </TableBody>
                )
              }
            }
            )}
        </table>
        <ConfirmDialog
          open={open_dialog_tem_a_certeza_que_quer_eliminar}
          onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
          onConfirm={handle_escolhe_qual_elimina}
          message="Deseja eliminar o registo?"
        />
        <ConfirmDialog
          open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
          onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
          onConfirm={() => handleCloseDialog()}
          message={mensagem_tem_a_certeza_de_apagar_alteracoes}
        />
      </TableContainer>
    </CustomThemeProvider>
  );
};
